import PowerMeters from './power_meters';
import PowerMeterConfigs from './power_meter_configs'
import AddPowerMeter from './add_power_meter';
import PowerMetersDashboard from './power_meter_management';
import PowerMetersDashboard2 from './power_meter_management2';
import NetworkMonitorDashboard from './network_management';

const powerMeterManagementRoutes = [
    {
        path: "/core/power_meter_management/power_meters_management",
        element: <PowerMeters />
    },
    {
        path: "/core/power_meter_management/power_meter_configs",
        element: <PowerMeterConfigs />

    },
    {
        path: "/core/power_meter_management/add_new_power_meter",
        element: <AddPowerMeter />

    },
     {
        path: "/core/power_meter_management/power_meters_management_dashboard",
        element: <PowerMetersDashboard />

    },
    {
        path: "/core/power_meter_management/power_meters_management_dashboard_2",
        element: <PowerMetersDashboard2 />

    },
    {
        path: "/core/power_meter_management/network_monitor_dashboard",
        element: <NetworkMonitorDashboard />

    }

]
export default powerMeterManagementRoutes